module.exports = __webpack_public_path__ + "static/2025-Great-Patient-Experience-Doctify-e917078e6f325eaa4fdfd54672e2e7c0.png";